"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VolumeOff = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var volume_1 = require("./volume");

var VolumeOff = function VolumeOff() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(volume_1.Volume, null), react_1.default.createElement("g", {
    clipPath: "url(#volume-icon-red-stroke)"
  }, react_1.default.createElement("path", {
    d: "M 1.3790786,0.7930992 23.20694,22.621062 22.620611,23.207479 18.934748,19.532961 18.934187,19.532289 6.7106219,7.3088341 6.7102407,7.3084415 0.79271159,1.379454 Z",
    stroke: "#fe4d4d"
  })), react_1.default.createElement("defs", null, react_1.default.createElement("clipPath", {
    id: "volume-icon-red-stroke"
  }, react_1.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};

exports.VolumeOff = VolumeOff;